import Vue from "vue"

Vue.prototype.goHome = () => __.platform.go()
Vue.prototype.$currency = value => {
  const currency = __.device.config("view_currency.view_currency")
  return `${value} ${currency || ""}`.trim()
}

Vue.mixin({
  activated: function() {
    if (this.$route.matched[0].components.default.name === this.$options.name) _$.log(`${this.$options.name} activated`)
  }
})

Vue.filter("capitalize", value => {
  if (!value) return ""
  value = value.toString()
  return value.capitalize()
})

Vue.filter("slugify", value => {
  if (!value) return ""
  value = value.slugify()
  return value
})

String.prototype.capitalize = function() {
  var letters = { İ: "i", Ş: "ş", Ğ: "ğ", Ü: "ü", Ö: "ö", Ç: "ç", I: "ı" }
  var string = this.replace(/(([İŞĞÜÖÇI]))/g, letter => letters[letter])

  return string.toLowerCase().replace(/\b\w/g, function(l) {
    return l.toUpperCase()
  })
}

String.prototype.snakeCase = function() {
  return this.replace(/\W+/g, " ")
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join("_")
}

String.prototype.slugify = function() {
  var str = this.replace(/^\s+|\s+$/g, "")
  str = str.toLowerCase()

  var from = "şğàáäâèéëêıìíïîòóöôùúüûñç·/_,:;"
  var to = "sgaaaaeeeeiiiiioooouuuunc------"
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i))
  }

  str = str
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")

  return str
}

String.prototype.host = function(append = "") {
  let checker = this.split(":").shift()
  if (["udp", "rtp", "http", "https", "hls", "rtmp", "rtsp", "BT"].indexOf(checker.toLowerCase()) !== -1) return this

  let value = (append + this).replace("//", "/")

  if (value.startsWith("/")) return __.platform.baseUrl + value
  else return __.platform.baseUrl + "/" + value
}
